import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/mock";

const MarqueeBanner = () => {
  return (
    <div
      className="relative border-b border-[#E5E0D8] bg-[#F9F7F3]"
      data-testid="marquee-banner"
    >
      <Marquee gradient={false} speed={34} pauseOnHover>
        {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
          <span key={i} className="flex items-center gap-3 px-8 py-2.5">
            <span className="marquee-dot" />
            <span
              className={`tracking-[0.12em] ${
                item.italic ? "font-serif italic text-[15px] text-[#C8A97E]" : "text-[13px] text-[#1A1A1A]"
              }`}
            >
              {item.text}
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default MarqueeBanner;
